const normalizeBase = (value) => {
  if (!value) return '';
  return String(value).trim().replace(/\/+$/, '');
};

const BACKEND_SHARE_BASE = 'https://cubebackend.azurewebsites.net';

const getShareUrl = (type, id) => {
  const safeType = String(type || '').trim();
  const safeId = String(id || '').trim();
  if (!safeType || !safeId) return '';
  const base = normalizeBase(BACKEND_SHARE_BASE);
  const path = `/share/${encodeURIComponent(safeType)}/${encodeURIComponent(
    safeId,
  )}`;
  return base ? `${base}${path}` : path;
};

export default getShareUrl;
